import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useRef, useState } from "react";

const MainWrap = styled.div`
    width: 100vw;
    height: 100vh;
    .showDiv {
        position: absolute;
        top:0;
        left:${(props)=>props.load>0?'100%':'0'};
        width:100vw !important;
        height:100vh !important;
        overflow:hidden;
        -webkit-transition: ${(props)=>props.load===0?'left 500ms ease-in':''};
        -moz-transition: ${(props)=>props.load===0?'left 500ms ease-in':''};
        -ms-transition: ${(props)=>props.load===0?'left 500ms ease-in':''};
        -o-transition: ${(props)=>props.load===0?'left 500ms ease-in':''};
        transition: ${(props)=>props.load===0?'left 500ms ease-in':''};
    }
`;

function useInterval(callback, delay) {
    const savedCallback = useRef(); // 최근에 들어온 callback을 저장할 ref를 하나 만든다.
  
    useEffect(() => {
      savedCallback.current = callback; // callback이 바뀔 때마다 ref를 업데이트 해준다.
    }, [callback]);
  
    useEffect(() => {
      function tick() {
        savedCallback.current(); // tick이 실행되면 callback 함수를 실행시킨다.
      }
      if (delay !== null) { // 만약 delay가 null이 아니라면 
        let id = setInterval(tick, delay); // delay에 맞추어 interval을 새로 실행시킨다.
        return () => clearInterval(id); // unmount될 때 clearInterval을 해준다.
      }
    }, [delay]); // delay가 바뀔 때마다 새로 실행된다.
  }

const AllFullMode = () => {

    const [statusUrl, setStatusUrl] = useState(0);
    const [load,setLoad] = useState();

    const setting = {
        infinite: true,
        speed: 1000,
        autoplay: true,
        // autoplaySpeed: 10000,
        autoplaySpeed: 3000,
        arrows:false,
        // afterChange:(current)=>{currentCheck(current)}
        // vertical: true,
        // dots: true
    }

    const urlArray = [
        'https://tss.hi-tdn.com/dashboard',
        'https://ams.hi-tdn.com/dashboard',
        'https://docs.google.com/spreadsheets/d/1FJuAy70ehJ8eXQ4jxBNeN_vfgMLwFHIHHZFIhEJRyKo/edit?usp=sharing'
    ]

    useInterval(()=>{
        const temp = statusUrl===2?0:statusUrl+1;
        setStatusUrl(temp)
    },20000)
    
    useEffect(()=>{
        setLoad(900);
    },[statusUrl]);

    useInterval(()=>{
        if(load!==0){
            setLoad(0);
        }
    },500)

    return (
        <MainWrap load={load}>
            <div className="showDiv">
                <iframe src={urlArray[statusUrl]} frameBorder={0} width='100%' height='100%'/>
            </div>
            {/* <Slider {...setting}>
                <div className="showDiv">
                    <iframe src='http://localhost:3000/dashboard' frameBorder={0} width='100%' height='100%'/>
                </div>
                <div className="showDiv">
                    <iframe src='http://ams.hi-tdn.com/dashboard' frameBorder={0} width={statusUrl!==''?'100%':'0px'} height={statusUrl!==''?'100%':'0px'}/>
                </div>
                <div className="showDiv">
                    <iframe src='https://docs.google.com/spreadsheets/d/1sw_s1lgPn0iEhka19EHzdAi6U4OjMrOnWkUH4SxAWWk/edit#gid=432969193' frameBorder={0} width='100%' height='100%' sandbox/>
                </div>
            </Slider> */}
            {/* <Slider {...setting}>
                <div className="showDiv">
                    <iframe src='https://docs.google.com/spreadsheets/d/1sw_s1lgPn0iEhka19EHzdAi6U4OjMrOnWkUH4SxAWWk/edit#gid=432969193' frameBorder={0} width='100%' height='100%'/>
                </div>
            </Slider> */}
        </MainWrap>
    )

}

export default AllFullMode;